var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-plyr',{staticClass:"video-dialog-player"},[_c('video',{attrs:{"preload":"metadata","poster":_vm.videoMediaData.thumb}},[_c('source',{attrs:{"src":_vm.videoMediaData.file,"type":"video/mp4"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }